import { render } from "./footers.vue?vue&type=template&id=db501e36&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"

import "./footers.vue?vue&type=style&index=0&id=db501e36&scoped=true&lang=scss"

import exportComponent from "E:\\guanwang\\zhongYuanGuanWang\\zhongyuanyuzhou_pc_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db501e36"]])

export default __exports__